import {useActions, useGetters, useMutators, useState} from './_default.js';
import {MAP_OBJECT_TYPE_HISTORY_EVENT} from "@/js/constants";
import HistoryPopup from "@/js/Components/MapPopup/HistoryPopup.vue";
export default {
    namespaced: true,
    state: {
        ...useState(),
        name: MAP_OBJECT_TYPE_HISTORY_EVENT,
        popupComponent: HistoryPopup,
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
